"use client";
import StarB from "@/public/images/starB.svg";
import Image from "next/image";
import MyLink from "@/components/shared/myLink/MyLink";
import { useGetAllServicesQuery } from "@/redux/features/api/dashboard/servicesApiSlice";
import Loader from "@/components/shared/Loader";
import Pagination from "@/components/shared/Pagination";
import { useState } from "react";

type Props = {
  params: {
    lang: "ar" | "en";
  };
};

const translations = {
  ar: {
    services: "خدماتنا",
    description:
      "اكتشف كيف يمكن لخدماتنا المتكاملة أن تدعم رحلتك الأكاديمية وتساعدك في اتخاذ قرارات مستنيرة حول دراستك الجامعية.",

    contactus: "تواصل معنا",
  },
  en: {
    services: "Our Services",
    description:
      "Discover how our integrated services can support your academic journey and help you make informed decisions about your university studies.",
    contactus: "Contact Us",
  },
};

export default function ServicesSection({ params }: Props) {
  const lang = params?.lang || "ar";
  const t = translations[lang];
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const {
    data: services,
    isLoading,
    error,
    refetch,
  } = useGetAllServicesQuery({ page: currentPage, limit: itemsPerPage, lang });
  const handlePageChange = (selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected + 1);
    refetch();
  };

  console.log({ services });
  return (
    <>
      <div className="bg-white">
        <div className="container py-[50px] xl:py-[100px]">
          <p className="text-25 text-darkText font-[600] text-center mb-5">
            {t?.services}
          </p>
          <p className="text-20 text-[#6C7278] text-center max-w-[723px] mx-auto mb-10">
            {t?.description}
          </p>
          {isLoading ? (
            <div className=" mx-auto">
              <Loader fullHeight />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {services?.data?.data?.map((service: any, index: number) => (
                <div
                  key={index}
                  className="flex flex-col justify-center items-center gap-5 px-5 py-10 border border-[#EBEBEB] rounded-[10px]"
                >
                  <Image
                    src={service.image}
                    width={60}
                    height={60}
                    alt={service.name[lang]}
                  />
                  <h3 className="text-20 text-center text-darkText font-[600]">
                    {service.name[lang]}
                  </h3>
                  <p className="text-16 text-descriptionText text-center line-clamp-3">
                    {service.short_description[lang]}
                  </p>
                  <MyLink
                    href={`/contactUs`}
                    className="text-20 text-primaryColor py-2 px-7 rounded-[10px] border border-primaryColor w-fit"
                  >
                    {t?.contactus}
                  </MyLink>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {services?.data?.paginate?.totalPages > 0 && (
        <Pagination
          pageCount={services?.data?.paginate?.totalPages}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          className="container flex justify-center"
        />
      )}
    </>
  );
}
